import { NodeItem } from "../../../../shared/utils/types";

export const TASK_TYPES = [
  { name: 'Task' },
  { name: 'Project' },
  { name: 'Bug' },
  { name: 'Story' },
  { name: 'Epic' },
  { name: 'Or anything you want!' },
  { name: '(just type in a custom item type)' },
];

export const STATUS_TYPES = [
  { name: 'To Do' },
  { name: 'In Progress' },
  { name: 'Blocked' },
  { name: 'Will Not Do' },
  { name: 'Done' },
  { name: 'Or anything you want!' },
  { name: '(just type in a custom status)' },
];

export const PRIORITIES = [
  { name: 'Low Priority' },
  { name: 'Normal Priority' },
  { name: 'High Priority' },
  { name: 'Very High Priority' },
  { name: 'Critical' },
  { name: 'Or anything you want!' },
  { name: '(just type in a custom priority)' },
];

export const HISTORY_HIGHLIGHT_TYPES = [
  ...TASK_TYPES,
  ...STATUS_TYPES,
  ...PRIORITIES,
];

export const DEFAULT_ITEM_VALUE : NodeItem = {
  id: "-1",
  parent_id: null,
  new: true,
  display_order: 0,
  subitems_expanded: false,
  hasChildren: false,
  children: [],
  title: '',
  type: '',
  status: '',
  priority: '',
  description: '',
  permission_type: '',
  assignees: [],
  attachments: [],
  subscribers: [],
  shared_with: [],
  tags: [],
  history: [],
  in_trash: false,
  size: 0,
  start_date: null,
  due_date: null,
};

export const THEME_NAMES = {
  DEFAULT: 'defaultTheme',
  SEA: 'seaTheme',
  NIGHT_SKY: 'nightSkyTheme',
};

export const DASHBOARD_THEMES = [
  {
    name: THEME_NAMES.DEFAULT,
    title: 'Default',
    image: 'default_theme.jpg',
    dashboardContentClass: 'default-background',
  },
  {
    name: THEME_NAMES.SEA,
    title: 'Sea',
    image: 'sea_theme.jpg',
    dashboardContentClass: 'sea-background',
  },
  {
    name: THEME_NAMES.NIGHT_SKY,
    title: 'Night Sky',
    image: 'night_theme.jpg',
    dashboardContentClass: '',
  },
];

export const PRIORITY_LIST = {
  'low priority': 'low-priority',
  'medium priority': 'medium-priority',
  'normal priority': 'normal-priority',
  'high priority': 'high-priority',
  critical: 'critical-priority',
  'very high priority': 'critical-priority',
};

export const STATUS_LIST = {
  'to do': 'to-do-status',
  'in progress': 'in-progress-status',
  done: 'done-status',
  complete: 'done-status',
  blocked: 'blocked-status',
};

export const APP_CONFIG = {
  NO_OF_EVENTS_IN_RECENT_HISTORY: 2,
};

export const WELCOME_TUTORIAL_DIALOG_OPTIONS = [
  {
    img: '/assets/tutorial_img_1.jpg',
    alt: 'tutorial_img_1.jpg',
    title: 'Click "+" to create an item.',
  },
  {
    img: '/assets/tutorial_img_2.jpg',
    alt: 'tutorial_img_2.jpg',
    title: 'Select options, or type in your own custom values.',
  },
  {
    img: '/assets/tutorial_img_4.jpg',
    alt: 'tutorial_img_4.jpg',
    title:
      ' Click and drag to put items in other items, or zoom into one item by clicking.',
  },
];

export const SEARCH_OPTIONS_DIALOGS = {
  COLUMNS: ['example', 'result'],
  DETAILS: [
    {
      example: 'my lovely item',
      result: 'Search by header (title, status, priority, tags)',
    },
    { example: 'status: to do', result: 'Search by status' },
    { example: 'priority: high priority', result: 'Search by priority' },
    { example: '#thebesttag #anothertag', result: 'Search by tags' },
    { example: 'title: the best item', result: 'Search by title' },
    { example: 'type: task', result: 'Search by type' },
    { example: 'description: bla bla', result: 'Search by description' },
    { example: 'id: f0245ae8d12c', result: 'Search by id' },
    { example: 'isDescendentOf: d68e270c8202', result: 'Search by parent id' },
  ],
};

export const HISTORY_ACTIONS = {
  ADD: 'add',
  REMOVE: 'remove',
  UNDELETE: 'undelete',
  UPDATE: 'update',
};

export const HISTORY_OBJECT_TYPES = {
  ITEM: 'item',
  SHARE_PERMISSION: 'share permission',
  ATTACHMENT: 'attachment',
  ATTACHMENTS: 'attachments',
  ASSIGNEE: 'assignee',
  SUBSCRIBER: 'subscriber',
  TAGS: 'tags',
};

export const HISTORY_BASIC_PROPERTIES = {
  'title' : 'title',
  'type' : 'type',
  'status' : 'status',
  'priority' : 'priority',
  'description' : 'description',
  'start_date' : 'start date',
  'due_date' : 'due date',
  'size' : 'size',
};